// FundDetailsController
app.controller('FundDetailsController', ['$scope', '$location', '$timeout', '$routeParams',
    'WdHttpService', 'sessionService', 'config', 'analyticsService', '$ocLazyLoad',
    function ($scope, $location, $timeout, $routeParams, WdHttpService, sessionService, config,
        analyticsService, $ocLazyLoad) {
        $ocLazyLoad.load(['https://platform-api.sharethis.com/js/sharethis.js#property=60083557abb5a60018e994a0&product=sticky-share-buttons',
            'https://www.gstatic.com/charts/loader.js']);
        var username = sessionService.get("cognito_username");

        // Init 
        $scope.init = async function () {
            await $scope.fetchAdviserSiteDetails();
            if (!$scope.brokerName) {
                if (!$scope.getBrokerName()) {
                    await $scope.updateBrokerPopup();
                    return;
                }
            }
            $scope.fundName = $routeParams.fundname;
            $scope.advisoryFeeStatus = 'NA';
            $scope.sliderData = [];
            $scope.fund_details = undefined;
            $scope.weightage = [];
            $scope.sectors = [];
            $scope.loaderGraph = true;
            $scope.subStatus = false;
            $scope.showPerformance = false;
            $scope.SIPOrLumpsumTabFlag = true;
            $scope.showSipPerformance = false;
            $scope.no_composition_data = true;
            $scope.investingMode = sessionService.get("investingMode") ? sessionService.get("investingMode") : "REAL";
            $scope.sipList = [];
            $scope.isUserInvested = false;
            await $scope.getFundDetails();
            $('#funds').addClass('active');
            if (sessionService.isLoggedIn()) {
                $scope.showLoading("#lodingButtonOptions");
                $scope.isUserInvested = await WdHttpService._is_user_invested($routeParams.fundname, $scope.investingMode);
                await $scope.setAdvisoryFeeStatus($routeParams.fundname, $scope.adviserUsername);
                await $scope.checkMandateRegistration();
                $scope.setupFinalInvestActionCallback();
                $scope.isServerCallCompleted = true;
                $scope.stopLoading("#lodingButtonOptions");
            } else {
                $scope.isServerCallCompleted = true;
            }
            await loadShareSocialMediaButtons();
            $scope.$evalAsync();
        }

        $scope.checkMandateRegistration = async function () {
            $scope.isMandateRegistered = false;
            await WdHttpService._get_dynamodb_user_profile(false)
                .then(async response => {
                    if ("advisortoMandateDetails" in response) {
                        if ($scope.adviserUsername in response.advisortoMandateDetails) {
                            $scope.isMandateRegistered = true;
                        }
                    }
                })
        }

        $scope.setupFinalInvestActionCallback = async function () {
            $scope.investButtonText = '';
            $scope.finalInvestActionCallback = function () { };

            if ($scope.isUserInvested) {
                $scope.investButtonText = 'Track';
                $scope.finalInvestActionCallback = () => $location.path('user-wealthbasket/' + $scope.adviserUsername + '/' + $routeParams.fundname);
            } else if (!$scope.isUserInvested && ($scope.advisoryFeeStatus == 'PAID' || $scope.isMandateRegistered)) {
                $scope.investButtonText = 'Invest';
                $scope.finalInvestActionCallback = () => $scope.onInvest();
            } else if (!$scope.isUserInvested && $scope.advisoryFeeStatus != 'PAID' && $scope.isMandateRegistered == false) {
                $scope.investButtonText = 'Subscribe';
                $scope.finalInvestActionCallback = () => $scope.onSubscribe();
            }
        }

        $scope.setAdvisoryFeeStatus = async function (fundName, adviserUsername) {
            await WdHttpService._check_advisory_fee(fundName, adviserUsername)
                .then(response => {
                    $scope.advisoryFeeStatus = response;
                }).catch(error => {
                    console.log(error);
                    $scope.advisoryFeeStatus = 'NA';
                })
        }

        $scope.getFundDetails = async function () {
            var data = {
                q: "fundName:" + $routeParams.fundname,
                f: "web_admin:" + $scope.webadminName
            }
            $scope.showPageLoader();
            await WdHttpService._get_funds(data)
                .then(async function (response) {
                    if (response.status == 200) {
                        var fund_details;
                        // This if condition is coded due to a server side bug to be fixed yet.
                        if (response.data.Items.length > 1) {
                            response.data.Items.forEach(fund => {
                                if (fund.fundName == $routeParams.fundname)
                                    fund_details = fund;
                            });
                        } else
                            fund_details = response.data.Items[0];
                        $scope.showCagrDetails = function () {
                            if (response.data.Items[0].fundReturnsComparison) {
                                $('#cagrModel').modal('show');
                                if (response.data.Items[0].fundReturnsComparison.returnType === "cagr") {
                                    $scope.isCagrDetails = true;
                                    $scope.isAbsoluteDetails = false;
                                } else {
                                    $scope.isCagrDetails = false;
                                    $scope.isAbsoluteDetails = true;
                                }
                            }
                        }
                        $scope.modFundName = fund_details.displayName;
                        $scope.benchmark = fund_details.benchmark;
                        $scope.fundName = fund_details.fundName;
                        $scope.description = fund_details.description;
                        $scope.adviserUsername = fund_details.adviserUsername;
                        $scope.feeAmount = fund_details.feeType.toLowerCase() == 'fixed' ? parseFloat(fund_details.fee) : (fund_details.feeType.toLowerCase() == 'percent' ? parseFloat(fund_details.fee * fund_details.minAmount / 100) : parseFloat(fund_details.fee));
                        $scope.gstAmt = $scope.feeAmount * 0.18;
                        $scope.totalAmt = $scope.feeAmount + $scope.gstAmt;
                        fund_details.fundIcon = fund_details.fundIcon != 'https://s3.amazonaws.com/wd-fund-icons/default.jpg' ? fund_details.fundIcon : 'assets/img/wealtbasket-icon-high.svg';
                        $scope.fund_details = fund_details;
                        $scope.fundComparisonStartTimestamp = fund_details.fundReturnsComparison ? fund_details.fundReturnsComparison.returnStartTimestamp : fund_details.startDate;
                        $scope.returnStartDate = fund_details.returnStartDate;

                        if (fund_details.feePeriod != undefined && fund_details.feePeriod > 0) {
                            if (fund_details.feePeriod == 12) {
                                $scope.feePeriod = 'Annually';
                            }
                            else if (fund_details.feePeriod == 6)
                                $scope.feePeriod = 'Semi-Annually';
                            else if (fund_details.feePeriod == 3)
                                $scope.feePeriod = 'Quarterly';
                            else if (fund_details.feePeriod == 1)
                                $scope.feePeriod = 'Monthly';
                            else
                                $scope.feePeriod = 'every ' + fund_details.feePeriod + ' Months';
                        }

                        angular.forEach(fund_details.childFund, function (value, key) {

                            $scope.sipList.push({
                                "fundName": value.fundName,
                                "minSipAmount": value.minAmount
                            })
                        });

                        if ($scope.fund_details.childFund != undefined) {
                            if ($scope.fund_details.childFund.length > 0) {
                                $scope.investmentSipAmt = parseInt($scope.fund_details.childFund[0].minAmount);
                                $scope.investmentSipAmtOriginally = parseInt($scope.fund_details.childFund[0].minAmount);
                                for (var i = 0; i < $scope.fund_details.childFund.length; i++) {
                                    if ($scope.fund_details.childFund[i].minAmount < $scope.investmentSipAmt) {
                                        $scope.investmentSipAmt = parseInt($scope.fund_details.childFund[i].minAmount);
                                        $scope.investmentSipAmtOriginally = parseInt($scope.fund_details.childFund[i].minAmount);
                                    }
                                }
                            }
                        }
                        await $scope.getStockWeightage();
                        $scope.period = $scope.fundComparisonStartTimestamp;
                        $scope.getPerformanceLineChart($scope.fundName, 'dw_stock_line_chart', $scope.modFundName);
                    }
                }).catch(error => {
                    console.log(error);
                    $scope.hidePageLoader();
                });
        }

        $scope.getStockWeightage = async function () {
            var fund = $routeParams.fundname;
            var adviser = $scope.adviserUsername;
            if ($scope.isUserLoggedIn) {
                $scope.loginToSeeComposition = false;
                $scope.no_composition_data = true;
                var data = { fund: fund, adviser: adviser };
                $scope.showPageLoader();
                await WdHttpService._user_composition(data)
                    .then(async function (response) {
                        if (response.status == 200) {
                            if (response.data.isFeePaid) {
                                $scope.advisoryFeeStatus = 'PAID';
                            } else {
                                $scope.advisoryFeeStatus = 'NA';
                            }
                            $scope.investmentAmt = parseInt(response.data.minLumpSumAmount);
                            $scope.investmentAmtOriginally = parseInt(response.data.minLumpSumAmount);

                            if (response.data.fundCompositions.length == 0) {
                                $scope.fundCompostionChart = false;
                                $scope.no_composition_data = false;
                            } else {
                                $scope.fundCompostionChart = true;
                                $scope.no_composition_data = true;
                                var weighStock = response.data.fundCompositions;
                                var sectors = [];
                                angular.forEach(weighStock, function (value, key) {
                                    $scope.weightage.push({
                                        "allocation": value.allocation,
                                        "stockName": value.symbol,
                                        "sector": value.sector
                                    });
                                    sectors[value.sector] = (sectors[value.sector] ? sectors[value.sector] : 0) + value.allocation;
                                });

                                for (var key in sectors) {
                                    $scope.sectors.push({
                                        "allocation": parseFloat(sectors[key].toFixed(2)),
                                        "sector": key
                                    });
                                }

                                initializeAccordianFlags($scope.sectors);
                                // pie chart
                                google.charts.load('current', { 'packages': ['corechart'] });
                                google.charts.setOnLoadCallback(drawChart);

                                function drawChart() {
                                    var fundCompositiondata = new google.visualization.DataTable();
                                    fundCompositiondata.addColumn('string', 'Task');
                                    fundCompositiondata.addColumn('number', 'Hours per Day');
                                    var weighStock = $scope.sectors;
                                    angular.forEach(weighStock, function (value, key) {
                                        fundCompositiondata.addRows([
                                            [value.sector, value.allocation]
                                        ]);
                                    });
                                    var fundCompositionoptions = {
                                        title: '',
                                        pieSliceText: 'none',
                                        legend: 'bottom',
                                        chartArea: { 'width': '80%', 'height': '80%' },
                                        colors: ['#516091', '#74bec1', '#adebbe', '#eef3ad', '#fad9ad', '#ffb6c1'],
                                        titleTextStyle: {
                                            color: '#333',
                                            fontSize: 12,
                                        },
                                        pieSliceTextStyle: {
                                            color: '#333',
                                            fontSize: 12,
                                        }
                                    };
                                    var fundCompositiondatachart = new google.visualization.PieChart(document.getElementById('piechart'));
                                    fundCompositiondatachart.draw(fundCompositiondata, fundCompositionoptions);
                                }
                            }
                        }
                        $scope.hidePageLoader();
                    })
                    .catch(error => {
                        console.log(error);
                        $scope.showErrorPopup('Composition failed to load due to some error.');
                        $scope.no_composition_data = false;
                        $scope.advisoryFeeStatus = 'NA';
                        $scope.hidePageLoader();
                    });
            } else {
                $scope.hidePageLoader();
                $scope.loginToSeeComposition = true;
            }
        }

        function initializeAccordianFlags(sectors) {
            $scope.accordianContentflags = [];
            for (let index = 0; index < sectors.length; index++) {
                if (index == 0)
                    $scope.accordianContentflags[index] = true;
                else
                    $scope.accordianContentflags[index] = false;
            }
        }

        $scope.displayStocks = function (index) {
            for (var i = 0; i < $scope.accordianContentflags.length; i++) {
                if (index == i)
                    $scope.accordianContentflags[i] = true;
                else
                    $scope.accordianContentflags[i] = false;
            }
        }

        $scope.changePerfomanceTab = function (SIPOrLumpsumTabFlag) {
            $scope.SIPOrLumpsumTabFlag = SIPOrLumpsumTabFlag;
            if (SIPOrLumpsumTabFlag) {
                $scope.getPerformanceLineChart($scope.fundName, 'dw_stock_line_chart', $scope.modFundName);
            } else {
                var funds = '';
                $scope.fund_details.childFund.forEach(element => {
                    funds += element.fundName + ',';
                });
                $scope.getPerformanceLineChart(funds.replace(/,\s*$/, ""), 'dw_stock_sip_line_chart', $scope.modFundName);
            }
        }

        $scope.getPastPeriod = function (period) {
            $scope.period = period;
            angular.element(document.querySelector(".btn-xs-small")).removeClass("disabled");
            if ($scope.SIPOrLumpsumTabFlag == false) {
                if ($scope.sipList.length > 0) {
                    $scope.pastSipPerformance(period)
                }
            } else {
                $scope.pastLumpsumPerformance(period)
            }
        }

        $scope.getBenchmarkData = function (benchmark) {
            $scope.benchmark = benchmark;
            angular.element(document.querySelector(".btn-xs-small")).removeClass("disabled");
        }

        $scope.pastLumpsumPerformance = function (period) {
            if ($scope.fund_details.childFund == undefined || $scope.fund_details.childFund.length == 0) {
                $scope.getPerformanceLineChart($scope.fundName, 'dw_stock_line_chart', $scope.modFundName, period);
            } else
                $scope.getPerformanceLineChart($scope.fundName, 'dw_stock_line_chart', $scope.modFundName, period);
        }

        $scope.pastSipPerformance = function (period) {
            if ($scope.fund_details.childFund.length > 0) {
                var funds = '';
                $scope.fund_details.childFund.forEach(element => {
                    funds += element.fundName + ',';
                });
                $scope.getPerformanceLineChart(funds.replace(/,\s*$/, ""), 'dw_stock_sip_line_chart', $scope.modFundName, period);
            }
        }

        //line chart
        $scope.getPerformanceLineChart = function (funds, divId, fundDisplayName, period) {
            var fundseperated = funds.split(',');
            var benchmark = $scope.benchmark;
            var displayName = fundDisplayName;
            var data = {
                fundArray: funds,
                benchmarkArray: benchmark,
                period: period ? period : $scope.period
            };

            if (!isNaN(data['period'])) {
                data['timestamp'] = data['period'];
                delete data['period'];
            }

            WdHttpService._fund_details_performace_graph(data)
                .then(function (response) {
                    if (response.status == 200) {
                        if (response.data.chartArray.length > 0) {
                            if (divId == 'dw_stock_sip_line_chart')
                                $scope.showSipPerformance = true;
                            else
                                $scope.showPerformance = true;

                            var chartData = response.data.chartArray;
                            var chartDataIndex = chartData[chartData.length - 1]
                            $scope.fundValue = chartDataIndex[fundseperated[0]];
                            $scope.timestampValue = response.data.chartArray[0].timestamp;

                            $scope.loaderGraph = false;

                            google.charts.load('current', { 'packages': ['corechart', 'line'] });
                            google.charts.setOnLoadCallback(drawTrendlines);

                            function drawTrendlines() {
                                var performanceRow = [];
                                var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
                                    'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
                                ];
                                angular.forEach(chartData, function (value, key) {
                                    var benchValue = value[$scope.benchmark]; //$scope.benchmark;
                                    var performValue = [];
                                    const dataPointDateString = new Date(value.timestamp);
                                    var dateDataPoint = months[dataPointDateString.getMonth()] + ' ' + dataPointDateString.getDate() + ', ' + dataPointDateString.getFullYear();
                                    for (var i = 0; i < fundseperated.length; i++) {
                                        performValue.push(value[fundseperated[i]]);
                                    }
                                    var dataPoint = [dateDataPoint, benchValue];
                                    dataPoint = dataPoint.concat(performValue);
                                    performanceRow.push(dataPoint);
                                });

                                var dataTable = [];
                                var columnHeadings = ['Date', $scope.benchmark];
                                columnHeadings = columnHeadings.concat(displayName);
                                dataTable.push(columnHeadings);
                                var divisionalNumber = 16;
                                if (performanceRow.length > 1000) {
                                    divisionalNumber = divisionalNumber * 5
                                } else if (performanceRow.length > 364) {
                                    divisionalNumber = divisionalNumber * 2
                                } else if (performanceRow.length < 32) {
                                    divisionalNumber = performanceRow.length; // show All data points available
                                }
                                var incrementalValue = parseInt(performanceRow.length / divisionalNumber);
                                if (divisionalNumber != performanceRow.length) // Add first day performance
                                    dataTable.push(performanceRow[0]);
                                for (let index = 0; index < performanceRow.length; index = index + incrementalValue) {
                                    dataTable.push(performanceRow[index]);
                                }

                                if (divisionalNumber != performanceRow.length) // Add last day performance
                                    dataTable.push(performanceRow[performanceRow.length - 1]);
                                var data = google.visualization.arrayToDataTable(dataTable);

                                var options = {
                                    curveType: 'function',
                                    hAxis: {
                                        title: 'Date'
                                    },
                                    vAxis: {
                                        title: '₹'
                                    },
                                    colors: ['#80d3ce', '#fdcf7d', '#f683bb'],
                                    animation: {
                                        duration: 1000,
                                        easing: 'out',
                                        startup: true
                                    },
                                    legend: { position: 'bottom' },
                                    chartArea:{top:40}
                                };
                                var fundChart = new google.visualization.LineChart(document.getElementById(divId));
                                fundChart.draw(data, options);
                            }
                        } else {
                            $scope.showPerformance = false;
                            $scope.showSipPerformance = false;

                        }
                    }
                });
        }

        $scope.investAction = async function () {
            $scope.finalInvestActionCallback();
        }

        $scope.onInvest = async function () {
            if (sessionService.isLoggedIn()) {
                if ($scope.feeAmount != 0) {
                    var eventData = {
                        'fundName': $scope.fundName.toLowerCase()
                    };
                    await analyticsService._push_custom_event_data_to_datalayer('started-investment', eventData);
                    var orderId = await $scope.getPendingActions($scope.fundName);
                    if (orderId) {
                        window.location.href = config[$scope.brokerName].orderPlacementUrl + "?orderId=" + orderId + "&action=order-placement&path=" + window.location.origin;
                    } else {
                        $scope.showErrorPopup("Sorry, something went wrong, Please try again later or connect with support team.");
                    }
                } else if ($scope.feeAmount == 0) {
                    // start normal subscription flow
                    $scope.onSubscribe();
                }
            } else {
                $location.path('/register-client').search({
                    path: window.location.href
                });
            }
        }

        $scope.onSubscribe = async function () {
            if ($scope.isUserLoggedIn) {
                var eventData = {
                    'fundName': $scope.fundName.toLowerCase()
                };
                await analyticsService._push_custom_event_data_to_datalayer('started-subscription', eventData);
                $location.path('/kyc').search({ 'fund': $routeParams.fundname });
            } else {
                $location.path('/login');
            }
            $scope.$evalAsync();
        }


        $scope.getPendingActions = async function (fundName) {
            var orderId = undefined;
            await WdHttpService._get_all_pending_actions(true)
                .then(async function (response) {
                    if (response.status == 200) {
                        try {
                            var pendingOrders = response.data.pendingOrderIds;
                            for (let index = 0; index < pendingOrders.length; index++) {
                                const value = pendingOrders[index];
                                if (value.fundName == fundName) {
                                    orderId = value.orderId;
                                    break;
                                }
                            }
                        } catch (error) {
                            console.log(error);
                        }
                    }
                }).catch(error => {
                    console.log(error);
                });
            return orderId;
        }

        $scope.downloadFactSheet = function () {
            if (navigator.userAgent.includes('wv')) {  //android webview check
                window.open($scope.fund_details.factSheet, '_self');
            } else
                window.open($scope.fund_details.factSheet, '_blank');
        }

        async function loadShareSocialMediaButtons() {
            if (window.__sharethis__)
                window.__sharethis__.initialize()
        }
    }
]);